import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NonNullableFormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { BaseFilterService, BaseQueryParamService } from 'base';
import {
  BaseCustomerProviderFilterFormInterface,
  FilterFormBaseCustomerProviders,
} from '../../_interfaces/base-customer-provider-filter-form.interface';

@Component({
  selector: 'base-customer-provider-list-filters',
  templateUrl: './base-customer-provider-list-filters.component.html',
})
export class BaseCustomerProviderListFiltersComponent implements OnInit, OnDestroy {
  @Input() locations: { value: string; name: string }[];
  @Input() filterValues: { [key in any]: any };

  filtersForm: FormGroup<BaseCustomerProviderFilterFormInterface> = this.fb.group({
    location: [[] as { name: string; value: string }[]],
    search: [''],
  });
  activeFilters: any[] = [];
  labels: any = {
    location: 'location.singular',
    search: 'search',
  };

  destroy$ = new Subject();

  constructor(
    private queryParamsService: BaseQueryParamService,
    private fb: NonNullableFormBuilder,
    public filterService: BaseFilterService,
    public activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.initFilterValuesByQueryParams();
    this.subscribeFormChanges();
  }
  ngOnDestroy() {
    this.destroy$.next(true);
  }

  initFilterValuesByQueryParams() {
    this.filterValues = this.filterService.setInitialFilterValuesByQueryParams(
      this.filterValues,
      {
        location: this.filterService.convertArrayToKeyValueObject(this.locations, 'value', 'name'),
      },
      ['search']
    );

    this.filtersForm.patchValue(this.filterValues);
    this.activeFilters = this.filterService.updateActiveFilters(this.filtersForm.getRawValue());
  }

  subscribeFormChanges(): void {
    this.filtersForm.valueChanges.pipe(takeUntil(this.destroy$), debounceTime(50)).subscribe(() => {
      this.activeFilters = this.filterService.updateActiveFilters(this.filtersForm.getRawValue());
      this.queryParamsService.filterSubject.next({
        filters: this.filtersForm.value,
        page: 1,
      });
    });
  }

  removeFilter(filter: FilterFormBaseCustomerProviders): void {
    this.filterService.removeFilter(this.filtersForm, filter);
  }

  clearFilters(): void {
    this.filtersForm.reset();
  }

  onSearchChange(query: string): void {
    this.filtersForm.controls.search.setValue(query);
    this.queryParamsService.filterSubject.next({
      page: this.activatedRoute.snapshot.queryParams.page,
      filters: this.filtersForm.value,
    });
  }
}
